// Re-export from the new supabase-native shim so existing imports of
// `@web/utils/trpc/trpcReact` keep working unchanged.
export { trpcReact, TrpcProvider } from '@web/utils/api/trpcReact';
